import { useSSRSelector } from 'src/redux';
import { PAGE_TYPE_ID } from 'src/utils/constants';

export const useGetTypeIdFromCanonicalDataStore = (id = null) => {
  const canonicalData = useSSRSelector((state) => state.catalogReducer.canonicalData);
  return {
    typeId: +id || +canonicalData?.item_group_details?.id,
    isTypeCollection: canonicalData?.type === PAGE_TYPE_ID.COLLECTION,
    isTypeCategory: canonicalData?.type === PAGE_TYPE_ID.CATEGORY,
    isTypeTags: canonicalData?.type === PAGE_TYPE_ID.TAG,
  };
};
